import PropTypes from 'prop-types';

import { useUserDateFormat } from '../../hooks/use-datetime-formats';

export const UserDateFormat = ({ value, includeYear = true }) => {
  const { formatUserDate } = useUserDateFormat();
  return formatUserDate(value || new Date(), includeYear);
};

UserDateFormat.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  includeYear: PropTypes.bool,
};
